import { render, staticRenderFns } from "./CriarClientes.vue?vue&type=template&id=0cac8408&"
import script from "./CriarClientes.vue?vue&type=script&lang=js&"
export * from "./CriarClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports